import React from 'react';
import { Stack, Typography } from '@mui/material';
import { BrokerGroupChip } from '@/admin/shared/chips/BrokerGroupChip';
import { useListAllBrokerGroupsQuery } from '@/admin/brokerGroups/api/brokerGroupsApi';

/**
 * Broker group ids as chips with their names (BrokerGroupChip), without the id tooltip, so
 * it doesn't cover the cell's problem tooltip. An id that isn't a broker group (once the
 * cached list has loaded) is shown as red text: it's always an error (checkRows).
 */
export const BrokerGroupsCell = ({ ids }) => {
	const { data: brokerGroups } = useListAllBrokerGroupsQuery();

	return (
		<Stack direction='row' sx={{ flexWrap: 'wrap', gap: 0.5, alignItems: 'center' }}>
			{ids.map((id) =>
				brokerGroups && !brokerGroups.some((brokerGroup) => brokerGroup.id === id) ? (
					<Typography key={id} variant='body2' color='error'>
						{id}
					</Typography>
				) : (
					<BrokerGroupChip key={id} id={id} showIdTooltip={false} />
				),
			)}
		</Stack>
	);
};
